import { tabClick } from 'store/search/searchActions';
import { createTabClickEvent } from '../eventCreators';
import { createTabClickEventPayload } from '../dataHelpers/createTabClickEventPayload';

const emitTabClickEvent = ({ payload }) => {
  const tabClickEvent = createTabClickEvent(
    createTabClickEventPayload({
      itemText: payload?.itemText,
      itemName: payload?.itemName,
      pageType: payload?.pageType,
      tabIndex: payload?.tabIndex,
      variant: payload?.variant,
    }),
  );

  return tabClickEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [tabClick]: emitTabClickEvent };
